export const LOGIN = 'connexion'
export const REGISTER = 'creer-un-compte'
